import React from 'react';

import Image from '../../Commons/Image/Image';
import BARRIO_PARQUE from '../../../assets/swiss-medical-center/centro_barrio_parque.jpg';

import styles from './SwissMedicalBarrioParque.module.scss';

const SwissMedicalBarrioParque = () => {
  return (
    <div className={styles.swiss_medical_barrio_parque}>
      <h3>Barrio Parque</h3>
      <p>
        <strong className={styles.swiss_medical_barrio_parque__redText}>Dirección:</strong> San
        Martín de Tours 2980, Capital Federal
      </p>
      <p>
        <strong className={styles.swiss_medical_barrio_parque__redText}>Turnos:</strong>{' '}
        0810-333-8876
      </p>
      <Image
        src={BARRIO_PARQUE}
        alt='Sede barrio parque'
        title='Barrio Parque'
        classes={styles.swiss_medical_barrio_parque__image}
      />
      <p>
        <strong>Swiss Medical Center Barrio Parque</strong> cuenta con un excelente equipo de
        profesionales y con cómodas instalaciones que le permiten brindar a sus clientes una
        excelente atención programada.
      </p>
      <strong className={styles.swiss_medical_barrio_parque__redText}>
        Especialidades Médicas
      </strong>
      <ul>
        <li>Clínica Médica: Lunes a viernes 8 hs. a 20 hs. | Sábado 8 hs. a 13 hs.</li>
        <li>Ortopedia y Traumatología: Lunes a viernes 8 hs. a 20 hs. | Sábado 8 hs. a 13 hs.</li>
        <li>Cardiología</li>
        <li>Cirugía General</li>
        <li>Cirugía plástica reparadora</li>
        <li>Gastroenterología</li>
        <li>Ginecología</li>
        <li>Hematología</li>
        <li>Neumonología</li>
        <li>Obstetricia</li>
        <li>Ortopedia y traumatología</li>
        <li>Otorrinolaringología</li>
        <li>Proctología</li>
        <li>Urología</li>
        <li>Oncología</li>
      </ul>
      <br />
      <strong className={styles.swiss_medical_barrio_parque__redText}>
        Estudios de diagnóstico
      </strong>
      <p>Equipado con tecnología de punta, el Servicio de Diagnóstico por Imágenes cuenta con: </p>{' '}
      <ul>
        <li>Resonancia Magnética Nuclear</li>
      </ul>
      <p>
        Contamos con un equipo de radiología Philips Easy Diagnost que permite realizar estudios con
        mayor seguridad para nuestros pacientes y mejor definición diagnóstica para los médicos, y
        un Ecógrafo Doppler Color Image Point Philips Agilent.
      </p>
    </div>
  );
};

export default SwissMedicalBarrioParque;
